import { NavLink } from "react-router";
import { useStarred } from "../lib/StarredContext";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `border-b-2 px-1 pb-2 text-sm font-medium ${
    isActive ? "border-sky-600 text-sky-700" : "border-transparent text-slate-500 hover:text-slate-700"
  }`;

export default function Tabs() {
  const { starred } = useStarred();

  return (
    <nav className="mb-6 flex gap-6 border-b border-slate-200">
      <NavLink to="/" end className={tabClass}>
        All stations
      </NavLink>
      <NavLink to="/starred" className={tabClass}>
        Starred ({starred.length})
      </NavLink>
    </nav>
  );
}
